export default "__VITE_ASSET__fa5109a7__"